import { Action, ActionTypes, ObtainRewardAction } from '../rule-api-client/types/rule.type';

export function ruleUsesReward(actions: Action[] | undefined | null, rewardId: string): boolean {
  if (!actions || !rewardId) {
    return false;
  }

  return actions.some(
    action =>
      action.kind === ActionTypes.REWARD_ATTRIBUTION &&
      (action as ObtainRewardAction).impact?.rewardId === rewardId,
  );
}
